(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
window.PEWNIAKI_ANALIZA = {
    plik:   '/assets/json/db/' + __pewniaki_inline_cfg[0] + '/analizy/model.json',
    wersja: __pewniaki_inline_cfg[1],
    lata:   '/assets/json/db/' + __pewniaki_inline_cfg[2] + '/lata/',
    pula:   JSON.parse(String(__pewniaki_inline_cfg[3])),
    typuje: JSON.parse(String(__pewniaki_inline_cfg[4])),
    // Zakres lat: suma SUROWYCH licznikow `main` z rocznikow, T liczone tutaj.
    // Bez p_asympt (brak funkcji chi-kwadrat w JS) i bez kalibracji.
    sumujLata: function (roczniki) {
        var A = window.PEWNIAKI_ANALIZA, hits = {}, N = 0;
        roczniki.forEach(function (r) {
            N += r.losowan || 0;
            Object.keys(r.main || {}).forEach(function (n) { hits[n] = (hits[n] || 0) + r.main[n]; });
        });
        var m = A.pula, p = A.typuje / m, E = N * p, war = N * p * (1 - p);
        if (!N || !war) { return { losowan: N, T: null, df: m - 1, p_asympt: null, pct_kalibrowany: null, max_z: null, c95: null, c99: null, poza: null, testy_powod: null }; }
        var suma = 0, maxZ = 0;
        for (var n = 1; n <= m; n++) {
            var O = hits[String(n)] || 0, d = O - E;
            suma += d * d / war;
            maxZ = Math.max(maxZ, Math.abs(d) / Math.sqrt(war));
        }
        return { losowan: N, T: (m - 1) / m * suma, df: m - 1, p_asympt: null, pct_kalibrowany: null,
                 max_z: maxZ, c95: null, c99: null, poza: null, testy_powod: null };
    },
    // Teksty z tr() — wspolne dla wnioskow i renderu (jezyk wybiera serwer).
    T13: {
        brakD:  __pewniaki_inline_cfg[5],
        brakZ:  __pewniaki_inline_cfg[6],
        stat:   __pewniaki_inline_cfg[7],
        pval:   __pewniaki_inline_cfg[8],
        mniej:  __pewniaki_inline_cfg[9],
        ponizej:__pewniaki_inline_cfg[10],
        powyzej:__pewniaki_inline_cfg[11],
        testyW: __pewniaki_inline_cfg[12],
        lataP:  __pewniaki_inline_cfg[13],
        okien:  __pewniaki_inline_cfg[14],
        powod:  __pewniaki_inline_cfg[15],
        pasmoK: __pewniaki_inline_cfg[16],
        pasmoP: __pewniaki_inline_cfg[17],
        pasmoB: __pewniaki_inline_cfg[18],
        wszyst: __pewniaki_inline_cfg[19],
        ostat:  __pewniaki_inline_cfg[20],
        lata:   __pewniaki_inline_cfg[21]
    },
    wnioski: function (o, klucz, dane) {
        var T = window.PEWNIAKI_ANALIZA.T13;
        if (!o) return [T.brakD];
        var f = function (v, d) { return (Math.round(v * Math.pow(10, d)) / Math.pow(10, d)).toString().replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); };
        var fp = function (v) { return v < 0.001 ? T.mniej : f(v, 3); };
        var p = [], maT = o.T != null && o.df > 0, testyOk = !o.testy_powod;
        if (maT) {
            var sd = Math.sqrt(2 * o.df), z = (o.T - o.df) / sd;
            p.push(T.stat.replace('%1', o.losowan).replace('%2', f(o.T, 1)).replace('%3', o.df).replace('%4', o.df).replace('%5', f(sd, 1)).replace('%6', f(z, 2)));
        }
        if (maT && testyOk && o.p_asympt != null) {
            p.push(T.pval.replace('%1', fp(o.p_asympt)).replace('%2', o.p_asympt < 0.05 ? T.ponizej : T.powyzej));
        } else if (maT && !testyOk) {
            p.push(T.testyW.replace('%1', o.testy_powod));
        } else if (maT) {
            p.push(T.lataP);
        }
        var okna = (dane && dane.okna) || {}, nOkien = 0, istotne = 0;
        Object.keys(okna).forEach(function (kl) {
            var w = okna[kl];
            if (w && w.powod == null && !w.testy_powod && w.p_asympt != null) { nOkien++; if (w.p_asympt < 0.05) istotne++; }
        });
        if (nOkien) p.push(T.okien.replace('%1', istotne).replace('%2', nOkien));
        return p.length ? p : [T.brakZ];
    },
    render: function (okno, klucz, dane) {
        var A = window.PEWNIAKI_ANALIZA, T = A.T13;
        var q = function (s) { return document.querySelector(s); };
        var tys = function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
        var f = function (v, d) { return v == null ? '—' : (Math.round(v * Math.pow(10, d)) / Math.pow(10, d)).toString().replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); };
        var fp = function (v) { return v == null ? '—' : (v < 0.001 ? '< 0,001' : f(v, 3)); };
        var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
        var pula = (dane && dane.pula) || A.pula;
        var sekcja = q('[data-model]');
        if (!okno) { if (sekcja) { sekcja.hidden = true; } return; }
        if (sekcja) { sekcja.hidden = false; }
        var N = okno.losowan || 0, maT = okno.T != null && okno.df > 0, testyOk = !okno.testy_powod;
        var sd = maT ? Math.sqrt(2 * okno.df) : null, z = maT ? (okno.T - okno.df) / sd : null;
        q('[data-model-n]').textContent = tys(N);
        q('[data-model-n2]').textContent = tys(N);
        q('[data-model-t]').textContent = maT ? f(okno.T, 1) : '—';
        q('[data-model-df]').textContent = maT ? okno.df : '—';
        q('[data-model-sd]').textContent = f(sd, 1);
        q('[data-model-z]').textContent = f(z, 2);
        q('[data-model-p]').textContent = testyOk ? fp(okno.p_asympt) : '—';
        q('[data-model-pct]').textContent = testyOk && okno.pct_kalibrowany != null ? Number(okno.pct_kalibrowany).toFixed(1).replace('.', __pewniaki_inline_cfg[22]) + '%' : '—';
        q('[data-model-testy-powod]').textContent = testyOk ? '' : T.powod.replace('%1', okno.testy_powod);
        q('[data-model-maxz]').textContent = f(okno.max_z, 2);
        q('[data-model-c95]').textContent = f(okno.c95, 2);
        q('[data-model-c99]').textContent = f(okno.c99, 2);
        q('[data-model-pasmo-zdanie]').textContent = okno.c95 == null
            ? T.pasmoK
            : (okno.poza && okno.poza.length
                ? T.pasmoP.replace('%1', okno.poza.join(', ')).replace('%2', pula)
                : T.pasmoB);
        // tabela okien — z pliku, wybrany wiersz wyrozniony; zakres lat dostaje wlasny wiersz
        var okna = (dane && dane.okna) || {}, kolejnosc = (dane && dane.okna_lista) || Object.keys(okna), wiersze = [];
        var wiersz = function (etykieta, o, wybrane) {
            var tOk = !o.testy_powod, zz = (o.T - o.df) / Math.sqrt(2 * o.df);
            return '<tr' + (wybrane ? ' aria-current="true"' : '') + '><td>' + (wybrane ? '<strong>' + esc(etykieta) + '</strong>' : esc(etykieta)) + '</td>'
                + '<td class="liczbowa">' + tys(o.losowan || 0) + '</td><td class="liczbowa">' + f(o.T, 1) + '</td><td class="liczbowa">' + o.df + '</td>'
                + '<td class="liczbowa">' + f(zz, 2) + '</td><td class="liczbowa">' + (tOk ? fp(o.p_asympt) : '—') + '</td><td class="liczbowa">' + f(o.max_z, 2) + '</td></tr>';
        };
        kolejnosc.forEach(function (kl) {
            var o = okna[kl];
            if (o && o.powod == null && o.T != null && o.df > 0) wiersze.push(wiersz(kl === 'all' ? T.wszyst : T.ostat.replace('%1', kl), o, String(kl) === String(klucz)));
        });
        if (!(klucz in okna) && maT) wiersze.push(wiersz(T.lata, okno, true));
        q('[data-model-okna] tbody').innerHTML = wiersze.join('');
    }
};
})();
